import { createRequestString, getResponseBytes, http, isHttpError } from 'services/base/http';
import { ResultKind } from 'services/base/types';
import { CreateEmailVerificationRequest, CreateEmailVerificationResponse } from './protos/email_verification_pb';

export type ResendResult =
  | { kind: ResultKind.OK }
  | { kind: ResultKind.SYSTEM_ERROR }
  | {
    kind: ResultKind.USER_ERROR;
    emailAlreadyVerifiedError?: string;
    resendThrottleError?: string;
  };

export class EmailVerificationService {
  static async resend(): Promise<ResendResult> {
    try {
      const request = new CreateEmailVerificationRequest();
      await http.post('/send-email-verification/', createRequestString(request));
      return { kind: ResultKind.OK };
    } catch (error) {
      if (isHttpError(error)) {
        if (error.response?.status && error.response.status < 500) {
          const httpResp = error.response;
          const response = CreateEmailVerificationResponse.deserializeBinary(getResponseBytes(httpResp));
          return {
            kind: ResultKind.USER_ERROR,
            emailAlreadyVerifiedError: response.getEmailAlreadyVerifiedError(),
            resendThrottleError: response.getResendThrottleError(),
          };
        }
      }
      return { kind: ResultKind.SYSTEM_ERROR };
    }
  }
}
